/**
 * 共享稿库路由文件
 * last modify lzy 2020.03.18
 */
'use strict';
angular.module('resCenterGXRouterModule', []).config(['$stateProvider', function($stateProvider) {
    $stateProvider.state('front.resourcectrl.share.resource', { // 共享稿库列表路由
        url: '/resource?nodeid&nodename&change&parentid&manutype', // manutype为分辨使用哪种模板
        views: {
            'resource@front.resourcectrl.share': {
                templateUrl: function($stateParams) {
                    var templateUrl = './resourceCenter/shared/share_main_tpl.html'; // 后面分的模板，这个是之前的，设为默认
                    if ($stateParams.manutype) {
                        templateUrl = './resourceCenter/shared/template/' + $stateParams.manutype + '.html';
                    }
                    return templateUrl;
                },
                controller: 'resourceCenterSharedCtrl'
            }
        }
    }).state('front.resourcectrl.share.quickpreview', { // 共享稿库快速预览路由
        url: '/quickpreview?nodeid&nodename&change&parentid&metadata&manutype', // manutype为分辨使用哪种模板,主要是为了配合列表模板使用
        views: {
            'resource@front.resourcectrl.share': {
                templateUrl: './resourceCenter/shared/quickPreview/main_tpl.html',
                controller: 'sharedQuickPreviewCtrl'
            }
        }
    });
}]);
